<template>
  <div class="opportunity-description">
    <card-top-info-component
      v-if="!fromOmnichannelDesktop"
      @new-task="$emit('new-task')"
      @closeByChat="$emit('closeByChat')"
      @singleVoipCall="$emit('singleVoipCall')"
      :opportunity="opportunity"
      :fromOmnichannelDesktop="fromOmnichannelDesktop"
      :newestChat="newestChat"
    />

    <div class="description-title">Escreva uma observação</div>

    <div class="sub-group">
      <description-field
        @selected="setSelected()"
        @blur="handleBlur"
        :class="{ 'selected-box': isSelected }"
        :grow="true"
        v-model="description"
      />

      <div v-show="isSelected" class="save-button">
        <b-button @click="save(true)" :disabled="hasSaveRequest" variant="light">Deletar</b-button>

        <b-button @click="save()" :disabled="hasSaveRequest" variant="primary">Salvar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

import CardTopInfoComponent from "@/views/components/Omnichannel/CardTopInfoComponent.vue";
import DescriptionField from "@/views/forms/components/DescriptionField.vue";

export default {
  components: {
    BButton,

    CardTopInfoComponent,
    DescriptionField,
  },

  data() {
    return {
      description: this.opportunity.description,
      hasSaveRequest: false,
      isSelected: false,

      savedMessage: "Descrição salva com sucesso!",
      deletedMessage: "Descrição deletada com sucesso!",
    };
  },

  props: {
    opportunity: {
      type: Object,
      required: true,
      default: null,
    },

    fromOmnichannelDesktop: {
      type: Boolean,
      required: false,
      default: false,
    },

    newestChat: {
      type: Object,
      required: false,
      default: null,
    },
  },

  methods: {
    setSelected() {
      this.isSelected = true;
    },

    handleBlur() {
      setTimeout(() => {
        if (!this.hasSaveRequest) {
          this.isSelected = false;
        }
      }, 100);
    },

    save(reset = false) {
      if (this.hasSaveRequest) return;

      this.hasSaveRequest = true;

      const updatedOpportunity = {
        id: this.opportunity.id,
        description: reset ? "" : this.description,
      };

      this.$store
        .dispatch("opportunityStore/save", updatedOpportunity)
        .then(() => {
          if (this.fromOmnichannelDesktop) {
            this.$store.commit("omnichannel/UPDATE");
          } else {
            this.$emit("saved", reset ? this.deletedMessage : this.savedMessage);
          }

          this.isSelected = false;
        })
        .finally(() => {
          this.hasSaveRequest = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.opportunity-description {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: 0.5rem 1.5rem 2rem 1.5rem;
  gap: 15px;
  overflow: hidden;

  .description-title {
    text-align: center;
    font-size: 21px;
    font-weight: 500;
  }

  .sub-group {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
  }

  .selected-box {
    border: solid 1px #046af3;
    border-bottom: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .save-button {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    padding: 7px 0px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border: solid 1px #046af3;
  }
}
</style>
